"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const abstractRefiners_1 = require("../abstractRefiners");

class MergeWeekdayComponentRefiner extends abstractRefiners_1.MergingRefiner {
  mergeResults(textBetween, currentResult, nextResult) {
    const newResult = nextResult.clone();
    newResult.index = currentResult.index;
    newResult.text = currentResult.text + textBetween + newResult.text;
    newResult.start.assign("weekday", currentResult.start.get("weekday"));

    if (newResult.end) {
      newResult.end.assign("weekday", currentResult.start.get("weekday"));
    }

    return newResult;
  }

  shouldMergeResults(textBetween, currentResult, nextResult) {
    const weekdayThenNormalDate = currentResult.start.isOnlyWeekdayComponent() && !currentResult.start.isCertain("hour") && nextResult.start.isCertain("day");
    return weekdayThenNormalDate && textBetween.match(/^,?\s*$/) != null;
  }

}

exports.default = MergeWeekdayComponentRefiner;